import { ChatState } from './chat.state';

export const selectStatus = (state: { chat: ChatState }) => state.chat.status;
